import ReactDOM from 'react-dom';

export const INITIAL_DELAY = 300;

export const deferFocus =
    (el: $TSFixMe, { selector = 'input', delay = INITIAL_DELAY, selectOnFocus }: $TSFixMe = {}) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { loggerService }: $TSFixMe) =>
        window.setTimeout(() => {
            let node = null;
            try {
                // eslint-disable-next-line react/no-find-dom-node
                node = ReactDOM.findDOMNode(el);
            } catch (err) {
                // element is no longer present in DOM
                node = null;
            }

            if (node) {
                const selectedNode = selector ? (node as $TSFixMe).querySelector(selector) : node;
                window.requestAnimationFrame(() => {
                    if (selectedNode) {
                        selectedNode.focus();
                        if (selectOnFocus) {
                            selectedNode.select();
                        }
                        if (document.activeElement !== selectedNode) {
                            loggerService.log('focus-error', 'Failed to focus element', {
                                delay,
                                selector,
                                selectedNode:
                                    selectedNode instanceof HTMLElement ? selectedNode.outerHTML : selectedNode,
                            });
                        }
                    }
                });
            }
        }, delay);
